import { UserInfoModel } from './server';

export const mapUserInfoFromModel = (model: UserInfoModel | null | undefined): UserInfo | undefined =>
    model
        ? {
              userName: model.userName ?? '',
              roles: model.roles ?? [],
          }
        : undefined;

export interface UserInfo {
    userName: string;
    roles: string[];
}
